<main @fade>
  <nb-card [nbSpinner]="loading">
    <nb-card-header>
      <app-list-actions [list]="this"/>
    </nb-card-header>

    <nb-card-body>
      <ngx-table
        #table
        [configuration]="configuration"
        [data]="data | async"
        [columns]="columns"
        [pagination]="pagination"
        (event)="eventEmitted($event)">
      </ngx-table>
    </nb-card-body>
  </nb-card>

</main>
